import styles from "./Layout.module.scss"

const Footer = () => {
  return (
    <footer  className={styles.footer}>
      <small>&copy; Copyright 2021, David Beer</small>
    </footer>
  )
}

export default Footer